import React, { Component } from 'react';
import { TextInput, Button, Link } from 'components';
import { showErrorToast } from 'utilities/notificationUtils';
import { isEmailValid, isPasswordValid } from 'utilities/validation';
import './styles.css';

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      emailError: false,
      passwordError: false
    };
    this.redirectIfLoggedIn();
  }

  redirectIfLoggedIn = () => {
    if (this.props.user) {
      this.props.redirectToHome();
    }
  }

  handleChange = event => {
    this.setState({
      [event.currentTarget.name]: event.currentTarget.value,  // set value
      [`${event.currentTarget.name}Error`]: false // clear error
    });
  }

  handleSubmit = event => {
    event.preventDefault()
    if (this.validate()) {
      this.login();
    }
  }

  validate = () => {
    const { email, password } = this.state;
    const emailValid = isEmailValid(email);
    const passwordValid = isPasswordValid(password);
    this.setState({
      emailError: !emailValid,
      passwordError: !passwordValid
    });
    return emailValid && passwordValid;
  }

  login = async () => {
    try {
      const { email, password } = this.state;
      await this.props.login(email.trim(), password.trim());
      this.props.redirectToHome();
    } catch (error) {
      console.log(error);
      showErrorToast('Error logging in.');
    }
  }

  render() {
    const { email, password, emailError, passwordError } = this.state;

    return (
      <div className="login">
        <h1 className="login__heading">Log in</h1>
        <form onSubmit={this.handleSubmit}>
          <div className="login__form">
            <TextInput
              name={'email'}
              label={'Email Address'}
              value={email}
              onChange={this.handleChange}
              error={emailError}
            />
            <TextInput
              name={'password'}
              label={'Password'}
              value={password}
              onChange={this.handleChange}
              type={'password'}
              error={passwordError}
            />
          </div>
          <Button
            type={'submit'}
            label={'Log In'}
          />
        </form>
        <Link
          to={'/forgot-password'}
          className={'login__forgot_password'}
        >
          Forgot Password?
        </Link>
        <div className="login__schedule__consult">
          <span className="type__link__secondary">New?</span>
          <Link
            to={'/create-account'}
            secondary
          >
           Create an Account
        </Link>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/screens/Login/Login.js